/*
Raghuarun 11/10/2022 2698966688 Dashboard table pagination fixes
akhila 11/11/2022 2698966688 removed title from the table
Sai Maheshwar 11/11/2022 3031689933  integrated locked process
Gummala Prakash 11/17/2022 3031593925 Removed Table Search and Toolbar.
Ashraf 12/26/2022 3031593925 fixed client code issues
Sohel 03/21/2023 2700520533 initial Value Changes
Akhila 03/23/2023 3031593925 modified the table column data "field" in table
Phaneendra 06/05/2023 3031593925 Fixed pagination page break issue
Sohel 06/12/2023 3031593925 Fixed Custom Window Reset Issue
Guru Prasad 06/23/1013 3031593925 Added Locked user name in the toast message
Guru Prasad 06/23/1013 3031593925 Changed toast message
Sohel 09/20/2023 5152729209 Fixed Issues moving from account to account
Gireesh 09/23/2023 5155351118 updated columns data
Dilip-pds 09/27/2023 5155351118 Changed field name of total balance
Dilip-pds 09/28/2023 5155351118 fixed SSN data display issue
uday 10/02/2023 5155351118 add scroll for table
*/
import React, { useEffect, useState, useContext } from 'react';
// import MaterialTable from "material-table";
import Grid from '@material-ui/core/Grid';
import { useDispatch } from 'react-redux';
import { makeStyles, TablePagination } from '@material-ui/core';
import { httpPaginationPost } from '../../util/Rest';
import { fetchColumns } from '../../redux/reducers/DashboardSettings';
import { ACCOUNTSUMMARY } from '../../constants/MicroServiceConstants';
import Avatar from 'react-avatar';
import NumberFormat from 'react-number-format';
import { tableIcons } from '../../components/TableIcons';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import formatSsnNumber from '../../util/SsnFormat';
import { resetAccData } from '../../redux/reducers/coreWindows/MultipleAccountInformation';
import PageLoader from '../../components/PageLoader';
import { ErrorSnackbar, SuccessSnackbar } from '../../components/CustomSnackBar';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';
import formatPhoneNumber from '../../util/PhoneFormat';
import { tablePageRows } from '../../constants/ReusableTablePagination';
import GuiTable from '../../components/FormComponents/GuiTable';
import { fetchAccountSummary, resetLockAccountStatus } from '../../redux/reducers/AccountSummary';
import { useRef } from 'react';
import { resetUDWForm } from '../../redux/reducers/UserDefinedWindow';
const useStyles = makeStyles((theme) => ({
  link: {
    color: '#5351fb !important',
  },
  searchText: {
    '& h2': {
      fontWeight: '900',
      color: '#000000',
      fontSize: '16px',
      [theme.breakpoints.down('sm')]: {
        marginTop: '12px',
      },
    },
    // "& h4": {
    //   fontWeight: "900",
    //   color: "#000000",
    //   fontSize: "0.825rem",
    // },
  },
  dataSearch: {
    fontSize: '16px !important',
  },
  resultSearch: {
    fontSize: '16px !important',
    paddingLeft: '5px',
  },
}));

export default function DashboardTable({
  searchedData,
  setSearchedData,
  searchedResults,
  setSearchResults,
  setAdvanceSearchData,
  accountSearched,
  setAccountSearched,
  lookupSearch,
  setSubmit,
  submit,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const tableRef = useRef();
  const tableRef2 = useRef();
  const [arrayLast, setArrayLast] = useState(false);
  const [text, setText] = useState('');
  const [rows, setRows] = useState(15);
  const {
    searchText,
    searchAny,
    setSearch,
    search: submitted,
  } = useContext(SelectTabContextProvider);
  const { isLoading, errorMsg } = useSelector(({ advanceSearch }) => advanceSearch);
  const { columnData, successMsg, columnStatus } = useSelector(({ columns }) => columns);
  const { udwlookupData, udwlookupisLoading } = useSelector(({ udwLookup }) => udwLookup);

  const {
    lockedAccountStatus,
    isLoading: findAccountLoading,
    accountSummaryData,
    lockedAccountNumber,
  } = useSelector(({ accountSummary }) => accountSummary);
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  const selectedRowAccNum = useRef(null);
  const lockUser = useSelector((state) => state?.accountSummary?.lockUser);

  useEffect(() => {
    dispatch(fetchColumns(user?.userName));
    setAdvanceSearchData([]);
  }, []);

  useEffect(() => {
    if ((tableRef?.current && submitted) || columnStatus === 200) {
      setText(searchText);
      tableRef.current.onQueryChange();
    }
  }, [submitted, columnStatus]);

  useEffect(() => {
    dispatch(resetAccData());
    dispatch(resetUDWForm());
  }, []);

  useEffect(() => {
    if (lockedAccountStatus === true) {
      setTimeout(() => {
        dispatch(resetLockAccountStatus());
      }, 7000);
    }
    if (lockedAccountStatus === false) {
      setTimeout(() => {
        dispatch(resetLockAccountStatus());
      }, 2000);
    }
    if (lockedAccountStatus === false && accountSearched) {
      setAccountSearched(false);
      sessionStorage.setItem(
        'activeWindow',
        history?.location?.state.activeWindow
          ? JSON.stringify(history?.location?.state.activeWindow)
          : '',
      );
      history.push({
        pathname: '/account-summary',
        state: {
          accountNumber:
            selectedRowAccNum?.current?.accountNumber || accountSummaryData?.accountNumber,
          fromWorkQueue: location?.state?.fromWorkQueue ? location.state.fromWorkQueue : '',
          workQueueName: location?.state?.workQueueName ? location.state.workQueueName : '',
          clientCode: selectedRowAccNum?.current?.clientCode || accountSummaryData?.clientNumber,
        },
      });
    }
  }, [lockedAccountStatus]);

  useEffect(() => {
    setSearchedData(udwlookupData);
  }, [udwlookupData]);

  const searchApiData =
    searchedData && searchedData.length > 0
      ? searchedData.map((item, i) => ({
        ...item,
        seedNumber: item?.accountNumber,
        id: i,
      }))
      : [];

  const colorCodes = ['#DCEDC8', '#C9EDF1', '#FFF9C4', '#FFFDE7', '#FBE9E7'];

  // TODO: get the columns here
  const handleCustomColumns = () => {
    const customColumns = [
      {
        title: 'Account Number',
        field: 'accountNumber',
        render: (rowData) => {
          return rowData && rowData.accountNumber ? (
            <button
              style={{
                background: 'none',
                outline: 'none',
              }}
              onClick={() => {
                selectedRowAccNum.current = rowData?.accountNumber
                  ? { accountNumber: rowData?.accountNumber, clientCode: rowData?.client }
                  : '';
                dispatch(fetchAccountSummary(rowData?.accountNumber ? rowData.accountNumber : ''));
              }}
              className={classes.link}
            >
              {rowData.accountNumber}
            </button>
          ) : null;
        },
      },
    ];

    if (columnData && columnData?.columnName) {
      for (const item of columnData?.columnName) {
        if (item === 'Client Code') {
          customColumns.push({
            title: 'Client Code',
            field: 'clientNumber',
          });
        } else if (item === 'Client Account Number') {
          customColumns.push({
            title: 'Client Account Number',
            field: 'clientReferenceNumber',
            type: 'numeric',
          });
        } else if (item === 'SSN') {
          customColumns.push({
            title: 'SSN',
            field: 'socialSecurityNumber',
            type: 'numeric',
            render: (rowData) => {
              return rowData && rowData.socialSecurityNumber
                ? formatSsnNumber(rowData.socialSecurityNumber)
                : null;
            },
          });
        } else if (item === 'Status') {
          customColumns.push({
            title: 'Status',
            field: 'statusCode',
            type: 'numeric',
          });
        } else if (item === 'Patient Name') {
          customColumns.push({
            title: 'Patient Name',
            field: 'patientName',
            minWidth: 220,
            type: 'string',
            render: (rowData) => {
              return rowData && rowData.patientName ? (
                <>
                  <Avatar
                    className="patient-avatar"
                    name={rowData.patientName}
                    size={33}
                    round="5px"
                  />
                  <span className="patient-name">{rowData.patientName}</span>
                </>
              ) : null;
            },
          });
        } else if (item === 'Phone Number') {
          customColumns.push({
            title: 'Phone Number',
            field: 'mobileNumber',
            type: 'numeric',
            minWidth: 130,
            render: (rowData) =>
              rowData['mobileNumber'] ? formatPhoneNumber(rowData['mobileNumber']) : '',
          });
        } else if (item === 'Cause Number') {
          customColumns.push({
            title: 'Cause Number',
            field: 'causeNumber',
          });
        } else if (item === 'City') {
          customColumns.push({
            title: 'City',
            field: 'city',
          });
        } else if (item === 'State') {
          customColumns.push({
            title: 'State',
            field: 'state',
          });
        } else if (item === 'Placement Date') {
          customColumns.push({
            title: 'Placement Date',
            field: 'placementDate',
            render: (rowData) =>
              rowData.placementDate ? moment(rowData.placementDate).format('MM/DD/YYYY') : '',
          });
        } else if (item === 'Total Balance') {
          customColumns.push({
            title: 'Total Balance',
            field: 'accountBalance ',
            type: 'numeric',
            numeric: true,
            render: (rowData) => {
              return rowData && rowData.accountBalance ? (
                <span className="total-balance">
                  <NumberFormat
                    value={rowData?.accountBalance}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </span>
              ) : (
                <span className="total-balance">
                  <NumberFormat
                    value={0.0}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </span>
              );
            },
          });
        }
      }
    }
    return customColumns;
  };

  return (
    <Grid item xs={12} className="">
      {!lookupSearch ? (
        <div className="dashboard-table accountsummry-tablescroll">
          <GuiTable
            title=""
            columns={handleCustomColumns()}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `${ACCOUNTSUMMARY}/find/all`;
                const regex = /(\d)\s+(?=\d)/g;
                const search = query.search.replace(/[^a-zA-Z 0-9/]/g, '');
                const subst = `$1`;
                const result = search.replace(regex, subst);
                const bodyObj = {
                  search: result,
                  searchBy: searchText === '' ? '' : searchAny?.key ? searchAny.key : '',
                  searchTerm: searchText,
                  limit: query.pageSize ? query.pageSize : null,
                  page: submitted
                    ? 1
                    : arrayLast && query.page >= 1
                      ? query.page
                      : arrayLast
                        ? (query.page <= 1 && query.page + 1) || query.page - 1
                        : query.page + 1,
                  orderDirection: query.orderDirection,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                };
                setAccountSearched(false);
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      resolve({
                        data: response.data.response.resultObject
                          ? response.data.response.resultObject
                          : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(response.data.response.resultObject.length === 1);
                      setSearchedData(
                        response?.data?.response?.resultObject
                          ? response.data.response.resultObject
                          : '',
                      );
                      setSearchResults(
                        response?.data?.response?.count ? response.data.response.count : 0,
                      );
                      setSearch(false);
                      setAccountSearched(true);
                      tableRef.current.dataManager['orderBy'] =
                        query?.orderBy?.tableData?.columnOrder;
                      tableRef.current.dataManager['orderDirection'] = query?.orderDirection;
                    } else {
                      throw new Error(
                        response?.data?.error || response?.statusText || 'Unknown Error',
                      );
                    }
                  })
                  .catch((response) => {
                    setSearchedData({});
                    setSearchResults(0);
                    setSearch(false);
                    setAccountSearched(true);
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 0,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              })
            }
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: { 'aria-label': 'Rows per screen' },
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            options={{
              search: false,
              toolbar: false,
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              debounceInterval: 500,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
              rowStyle: (rowData) => ({
                backgroundColor:
                  rowData.disposition && Number(rowData.disposition[0]) <= 5
                    ? colorCodes[Number(rowData.disposition[0]) - 1]
                    : '#ffff',
              }),
            }}
          />
        </div>
      ) : (
        <div className="dashboard-table">
          <GuiTable
            title={
              <div className={classes.searchText}>
                <h2>
                  <span className={classes.dataSearch}>
                    {searchApiData?.length > 0 || searchApiData?.resultObject?.length > 0
                      ? `Search Results for: ${text}`
                      : null}
                  </span>
                  <span className={classes.resultSearch}>
                    We found &quot;{searchApiData?.length}&quot; results
                  </span>
                </h2>
              </div>
            }
            columns={handleCustomColumns()}
            icons={tableIcons}
            tableRef={tableRef2}
            data={searchApiData}
            isLoading={udwlookupisLoading}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: { 'aria-label': 'Rows per screen' },
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            options={{
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              search: true,
              debounceInterval: 500,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
              rowStyle: (rowData) => ({
                backgroundColor:
                  rowData.disposition && Number(rowData.disposition[0]) <= 5
                    ? colorCodes[Number(rowData.disposition[0]) - 1]
                    : '#ffff',
              }),
            }}
          />
        </div>
      )}
      {(isLoading || findAccountLoading) && <PageLoader />}
      {lockedAccountStatus && (
        <ErrorSnackbar
          errorMsg={`Account ${lockedAccountNumber} has been locked by ${lockUser}, please try again later.`}
        />
      )}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </Grid>
  );
}
